import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas';
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import { NoAcceso } from '../../components/NoAcceso';
import LoadingOverlay from '../../components/LoadingOverlay'


import { UsuariosRoles } from './components/UsuariosRoles';
import { Roles } from './components/Roles';
import { RolesPantallas } from './components/RolesPantallas';
import { serverApi } from '../../api';
import { CrearUsuarioModal } from './components/CrearUsuarioModal';




const pasarMayusculas = (ev) => {
    ev.target.value = ev.target.value.toUpperCase();
}


const MySwal = withReactContent(Swal);

const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'LightSeaGreen', timer: 15000 }) }
const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({
        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'LightSeaGreen',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}


export const UsuariosPage = () => {

    useHideMenu(false);
    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);
    const pantallas = useGetPantallas();

    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tab, setTab] = useState('usuarios');

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'nombreCompleto',
        sortDir: 'asc',

    });

    // tabla
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.ceil(total / query.limit);

    const [searchInput, setSearchInput] = useState('');


    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            // return <Navigate to="/ingreso" />
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])






    useEffect(() => {

        const codigoEntidad = usuario.codigoEntidad
        // const codigoUbicacion = usuario.codigoUbicacion

        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
                console.log(query);


                const resp = await serverApi.post(
                    `/usuarios/lista-usuarios`,
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );

                setData(resp.data.lista || []);
                setTotal(resp.data.total || 0);

            } catch (error) {
                console.error("Error al obtener tipos de atención", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();

    }, [query, usuario.codigoEntidad, usuario.codigoUbicacion])


    useEffect(() => {
        if (!socket) return;

        const handler = (lista) => {
            console.log(lista);
            setData(lista.lista);
        };

        socket.on('lista-usuarios', handler);

        return () => {
            socket.off('lista-usuarios')
        }
    }, [socket])

    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 800);

        return () => clearTimeout(timeout);

    }, [searchInput]);


    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };

    const inactivaUsuario = async (uidUsuario, accion) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');


        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })

        if (!confirmacion.value) return false;

        try {
            setIsLoading(true);

            await serverApi.post(
                `/usuarios/inactiva-usuario`,
                {
                    ...query,
                    uidUsuario,
                    accion,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const registraUsuario = async (info) => {


        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/usuarios/registra-usuario`,
                {
                    ...info,
                    codigoEntidad,
                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
            }

        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }

    }

    const editaUsuario = async (ev, uidUsuario) => {

        const campo = ev.target.id.split("_")[0];
        const valor = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.value;
        const valorAnterior = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.defaultValue;


        if (valor === valorAnterior) return

        if (campo === "password") {
            const confirmacion = await sweetConfirm("Atención", "Esta seguro de cambiar el password?", "warning").then((result) => {
                return (result);
            })

            if (!confirmacion.value) return false;
        }

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {
            setIsLoading(true);

            await serverApi.post(
                `/usuarios/edita-usuario`,
                {
                    ...query,
                    campo,
                    valor,
                    uidUsuario,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);

        }




    }


    if (usuario.uidUsuario === null) {
        return (<></>)
    }
    else if (!pantallas.includes("usuarios")) {
        return (<NoAcceso />)
    } else {

        return (
            <>
                {isLoading && <LoadingOverlay />}

                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{ minHeight: '100vh' }}>

                    <Tabs
                        id="controlled-tab-example"
                        activeKey={tab}
                        onSelect={(k) => setTab(k)}
                        className="mb-3 justify-content-end"
                    >
                        <Tab eventKey="usuarios" title="Usuarios">
                            {/* <div> */}

                            <div className='row'>
                                <div className='col-lg-2 col-12 '>
                                    <button
                                        className='btn btn-success m-3'
                                        onClick={() => setShowModal(true)}
                                    >
                                        Agregar Usuario
                                    </button>

                                    <CrearUsuarioModal
                                        show={showModal}
                                        onClose={() => setShowModal(false)}
                                        onSave={(datos) => registraUsuario(datos)}
                                    />

                                </div>
                            </div>



                            <div className='row rounded shadow p-3'>

                                <div className='col-12'>
                                    <div className='float-start col-lg-4 col-12 pagination'>
                                        <button
                                            className='btn btn-sm btn-secondary m-1'
                                            onClick={() => paginate(query.page - 1)}
                                            disabled={query.page === 1}
                                        >
                                            {'<'}
                                        </button>

                                        <button
                                            className='btn btn-sm btn-secondary m-1'
                                            onClick={() => paginate(query.page + 1)}
                                            disabled={data.length <= query.limit}

                                        >
                                            {'>'}
                                        </button>
                                    </div>

                                    <div className=' float-end col-lg-4 col-12'>

                                        <input
                                            type='text'
                                            placeholder='Buscar...'
                                            className='form-control'
                                            value={searchInput}
                                            onChange={(ev) => setSearchInput(ev.target.value)}
                                        />

                                    </div>

                                </div>

                                <div className='col-12'>
                                    <Table responsive="md" striped hover style={{ minWidth: 600 }} className='max600'>
                                        <thead>
                                            <tr>
                                                <th width={'5%'}></th>
                                                <th width={'25%'} onClick={() => handleSort('usuario')} >
                                                    Usuario
                                                    {query.sortBy === 'usuario' && query.sortDir === 'asc' && '▲'}
                                                    {query.sortBy === 'usuario' && query.sortDir === 'desc' && '▼'}
                                                </th>
                                                <th width={'45%'} onClick={() => handleSort('nombreCompleto')} >
                                                    Nombre Completo
                                                    {query.sortBy === 'nombreCompleto' && query.sortDir === 'asc' && '▲'}
                                                    {query.sortBy === 'nombreCompleto' && query.sortDir === 'desc' && '▼'}
                                                </th>

                                                <th width={'25%'}>Password</th>

                                            </tr>
                                        </thead>

                                        <tbody width={'100%'}  >

                                            {

                                                data.length === 0
                                                    ? (<tr>
                                                        <td width={'100%'} style={{ textAlign: 'center' }}> No Hay Registros </td>
                                                    </tr>
                                                    )
                                                    :
                                                    data.map((item) => (

                                                        <tr key={item.uidUsuario}>
                                                            <td width={'5%'}>

                                                                {(item.indActivo === 1)
                                                                    ? (
                                                                        <>
                                                                            <button
                                                                                className='btn btn-sm btn-danger'
                                                                                onClick={() => inactivaUsuario(item.uidUsuario, 0)}
                                                                            >
                                                                                <i className='fa-solid fa-minus'></i>
                                                                            </button>{' '}
                                                                            {/* <button
                                                                            className='btn btn-sm btn-success'
                                                                            onClick={() => permisosUsuario( item.uidUsuario ) }
                                                                        > 
                                                                            <i className="fa-solid fa-lock"></i>
                                                                        </button> */}
                                                                        </>
                                                                    )
                                                                    : (
                                                                        <button
                                                                            className='btn btn-sm btn-success'
                                                                            onClick={() => inactivaUsuario(item.uidUsuario, 1)}
                                                                        >
                                                                            <i className='fa-solid fa-plus'></i>
                                                                        </button>
                                                                    )

                                                                }



                                                            </td>
                                                            <td width={'25%'}>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`usuario_${item.uidUsuario}`}
                                                                    defaultValue={item.usuario.toUpperCase()}
                                                                    maxLength={20}
                                                                    onInput={pasarMayusculas}
                                                                    onBlur={(ev) => editaUsuario(ev, item.uidUsuario)}
                                                                />
                                                            </td>
                                                            <td width={'45%'}>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`nombreCompleto_${item.uidUsuario}`}
                                                                    defaultValue={item.nombreCompleto.toUpperCase()}
                                                                    maxLength={200}
                                                                    onInput={pasarMayusculas}
                                                                    onBlur={(ev) => editaUsuario(ev, item.uidUsuario)}
                                                                />
                                                            </td>

                                                            <td width={'25%'}>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    id={`password_${item.uidUsuario}`}
                                                                    onBlur={(ev) => editaUsuario(ev, item.uidUsuario)}
                                                                    maxLength={20}

                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                            }
                                        </tbody>
                                    </Table>

                                    <div className='pagination'>
                                        <button
                                            className='btn btn-sm btn-secondary m-1'
                                            onClick={() => paginate(query.page - 1)}
                                            disabled={query.page === 1}
                                        >
                                            {'<'}
                                        </button>

                                        <button
                                            className='btn btn-sm btn-secondary m-1'
                                            onClick={() => paginate(query.page + 1)}
                                            disabled={data.length <= query.limit}

                                        >
                                            {'>'}
                                        </button>
                                    </div>
                                </div>


                            </div>




                            {/* </div> */}
                        </Tab>
                        <Tab eventKey="usuariosRoles" title="Asignación Roles a Usuarios">
                            <UsuariosRoles />
                        </Tab>
                        <Tab eventKey="rolesPantallas" title="Roles/Pantallas">
                            <RolesPantallas />
                        </Tab>
                    </Tabs>





                </div>
            </>
        )
    }
}
